module.exports = __webpack_public_path__ + "static/media/logoMississippi.74440c52.png";